import SearchBox from './search-box';
import SlxSearchEngine from './slx-search-engine';

export default (di) => {
	di
		.setType({type: SearchBox, name: 'SearchBox', parent: 'PageComponent'})
		.setType({type: SlxSearchEngine, name: 'SlxSearchEngine', parent: 'SearchEngine', params: {
			searchUrl: di.lazyValue('search/searchUrl')
		}})
		.set('search/engine', di.lazyNew('SlxSearchEngine'))

		.setParams('Search', {
			updateQueryString: false,
			searchOnEmpty: false,
			extraParams: []
		})
	;
};
